









export default {
  name: "Layout",
  props: ["classPrefix"],
};
